import { ref } from 'vue';

// Create a reactive language reference
console.log('window.App', window.App);
const currentLanguage = ref(window.App?.language || 'en');

// Centralized language management
function setLanguage(newLanguage) {
    const oldLanguage = currentLanguage.value;
    currentLanguage.value = newLanguage;

    // Update window.App for backward compatibility
    if (window.App) {
        window.App.language = newLanguage;
    }

    // Dispatch custom event for any external listeners
    window.dispatchEvent(new CustomEvent('languageChanged', {
        detail: { oldLanguage, newLanguage }
    }));
}

export default {
    install(app) {
        // Provide reactive language to all components
        app.provide('currentLanguage', currentLanguage);

        // Add global properties for easy access
        app.config.globalProperties.$currentLanguage = currentLanguage;
        app.config.globalProperties.$setLanguage = setLanguage;

        // Expose setLanguage globally for Crowdin to use
        window.App = window.App || {};
        window.App.setLanguage = setLanguage;
    }
}; 